import Competition from './PhotowallReducer';
import { combineReducers } from 'redux';

const rootReducer = combineReducers({
    competition: Competition
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js